import ApiRequestor from './ApiRequestor';

export class UsersService {
    public static async GetUsers() {
        return await ApiRequestor.get('GetUsers');
    }
}
